export default "__VITE_ASSET__6189a29f__"